import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import CorrespondingMethods from '../../components/CorrespondingMethods';
import quizBg from '../../../../../../assets/sme/sso/topic2-quiz-bg.png';
interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const quiz = paragraphsSettings?.quiz;
  const handleCorrespondingMethodsComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-sso-section3-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <CorrespondingMethods
        title={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.subTitle}
        items={paragraphsSettings?.correspondingMethodsItems}
        id="student-training-sso-section3-1"
        onComplete={handleCorrespondingMethodsComplete}
      />
      <div id="student-training-sso-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          quizImg={quizBg}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-sso-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
